import omit from 'lodash/omit';
import { vpAccessTokenRequest } from './axios';
import UserModel from '../models/UserModel';
import SiteModel from '../models/SiteModel';
import ConnectedProduct from '../../server/model/ConnectedProduct';

const apiRoute = `${window.vbcConfig.host}/api`;

export async function fetchUserByConnectedProduct(opts: {
  connectedProductAltId?: string | null;
  workId?: string | null;
}): Promise<UserModel | null> {
  let res;
  try {
    res = await vpAccessTokenRequest({
      method: 'get',
      url: `${apiRoute}/v1/connectedProduct`,
      params: { altId: opts.connectedProductAltId, workId: opts.workId },
    });
  } catch (e) {
    // Only a true 404 (no such connected product) resolves to null here.
    // A 403 propagates so SessionContext can tell it apart from a 404 and
    // offer the user a chance to sign in again before giving up.
    if (e.response?.status !== 404) {
      throw e;
    }
  }

  return res?.data
    ? {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...(res.data as any).user,
        connectedProduct: omit(res.data as ConnectedProduct, 'user'),
      }
    : null;
}

export async function updateSiteData(
  connectedProductAltId: string,
  siteData: SiteModel
): Promise<void> {
  await vpAccessTokenRequest({
    method: 'put',
    url: `${apiRoute}/v1/connectedProduct/${connectedProductAltId}`,
    data: { siteModel: siteData },
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function publish(connectedProductAltId: string, data: SiteModel): Promise<any> {
  return await vpAccessTokenRequest({
    method: 'post',
    url: `${apiRoute}/v1/connectedProduct/${connectedProductAltId}/publish`,
    data,
  });
}

export async function geoCodeAddress(
  connectedProductAltId: string,
  address: string,
  language = 'en'
) {
  const response = await vpAccessTokenRequest({
    method: 'post',
    url: `${apiRoute}/v1/connectedProduct/${connectedProductAltId}/addresses/geocode`,
    data: { address, language },
  });

  return { lat: response.data.lat as number, lng: response.data.lng as number };
}
